import { defaultLocale, locales, Locale } from './locale';

export const isLocaleString = (str: string) =>
  /^[a-zA-Z]{2}(?:-[a-zA-Z]{2})?$/.test(str);

export const isSupportedLocale = (locale: string): locale is Locale => {
  return locales.includes(locale as Locale);
};

export const transformLocale = (locale?: string) => {
  if (!locale) return defaultLocale;
  if (isSupportedLocale(locale)) {
    return locale;
  }

  // pt-PT -> pt
  if (locale.length > 2) {
    const shortLocale = locale.substring(0, 2);
    if (isSupportedLocale(shortLocale)) {
      return shortLocale;
    }
  }

  // pt -> pt-PT
  if (locale.length === 2) {
    const longLocale = `${locale.toLowerCase()}-${locale.toUpperCase()}`;
    if (isSupportedLocale(longLocale)) {
      return longLocale;
    }
  }

  return defaultLocale;
};

export const toLongLocale = (locale?: string) => {
  if (!locale) return defaultLocale;

  if (!isSupportedLocale(locale)) {
    locale = transformLocale(locale);
  }

  // this is going to fail when we add support for any locales that are not the same language and country codes (e.g. en-US)
  if (locale.length === 2)
    return `${locale.toLowerCase()}-${locale.toUpperCase()}`;
  return locale;
};
